import createSvgIcon from '@ixigo/icons/utils/createSvgIcon';
import { Fragment } from 'react';

export const AnimatedCheckCircleFilled = createSvgIcon(
  <Fragment>
    <defs>
      <mask
        id="tick-mask"
        maskUnits="objectBoundingBox"
        maskContentUnits="objectBoundingBox"
      >
        <rect x="0" y="0" width="1" height="1" fill="white" />
        <path
          d="M0.2333,0.5389 L0.4056,0.7111 L0.7667,0.3000"
          fill="none"
          stroke="black"
          strokeWidth="0.1111"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="0.7906"
          strokeDashoffset="0.7906"
          visibility="hidden"
        >
          <animate
            attributeName="visibility"
            from="hidden"
            to="visible"
            begin="1.1s"
            dur="0.001s"
            fill="freeze"
          />
          <animate
            attributeName="stroke-dashoffset"
            from="0.7906"
            to="0"
            begin="1.1s"
            dur="0.4s"
            fill="freeze"
            calcMode="spline"
            keySplines="0 0 0.58 1"
          />
        </path>
      </mask>
    </defs>

    <g transform="translate(12,12)">
      <g transform="scale(1)">
        <circle
          cx="0"
          cy="0"
          r="9"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray="56.5487"
          strokeDashoffset="56.5487"
          transform="rotate(-90)"
        >
          <animate
            attributeName="stroke-dashoffset"
            from="56.5487"
            to="0"
            begin="0s"
            dur="0.6s"
            fill="freeze"
            calcMode="spline"
            keySplines="0.4 0 0.2 1"
          />
        </circle>

        <circle
          cx="0"
          cy="0"
          r="9"
          fill="currentColor"
          opacity="0"
          mask="url(#tick-mask)"
        >
          <animate
            attributeName="opacity"
            from="0"
            to="1"
            begin="0.6s"
            dur="0.3s"
            fill="freeze"
            calcMode="spline"
            keySplines="0.4 0 0.2 1"
          />
        </circle>

        <animateTransform
          attributeName="transform"
          type="scale"
          from="1"
          to="1.2"
          begin="0.6s"
          dur="0.3s"
          fill="freeze"
          calcMode="spline"
          keySplines="0 0 0.58 1"
        />

        <animateTransform
          attributeName="transform"
          type="scale"
          from="1.2"
          to="1"
          begin="0.9s"
          dur="0.2s"
          fill="freeze"
          calcMode="spline"
          keySplines="0.42 0 1 1"
        />
      </g>
    </g>
  </Fragment>,
  'AnimatedCheckCircleFilled',
);
